/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './products/list_products';
import './products/list_recommended_products';
import './products/list_mpo_recommended_products';
import './products/search_products';
import './products/search_internal_products';
import './promotions/create_promotion';
import './promotions/retrieve_promotion';
import './warranty_products/create_warranty_product';
import './warranty_products/create_warranty_products_order';
import './warranty_products/list_all_warranty_products';
import './warranty_products/list_warranty_products';
import './warranty_products/search_warranty_products';
import './taxons/list_product_taxons';
import './products/list_software_product_groups';
import './orders/update_line_item_quantity';
import './orders/update_internal_line_item_quantities';
import './orders/retrieve_latest_active_order';
import './idv/retrieve_idv_status';
import './orders/retrieve_internal_order';
import './orders/retrieve_order';
import './orders/create_internal_order';
import './orders/hide_internal_order';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "ShopService": {
                    "methods": {
                      "ListProducts": {
                        "requestType": "squareup.solidshop.v2.service.ListProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListProductsResponse"
                      },
                      "ListRecommendedProducts": {
                        "requestType": "squareup.solidshop.v2.service.ListRecommendedProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListRecommendedProductsResponse"
                      },
                      "ListMpoRecommendedProducts": {
                        "requestType": "squareup.solidshop.v2.service.ListMpoRecommendedProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListMpoRecommendedProductsResponse"
                      },
                      "SearchProducts": {
                        "requestType": "squareup.solidshop.v2.service.SearchProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.SearchProductsResponse"
                      },
                      "SearchInternalProducts": {
                        "requestType": "squareup.solidshop.v2.service.SearchInternalProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.SearchInternalProductsResponse"
                      },
                      "CreatePromotion": {
                        "requestType": "squareup.solidshop.v2.service.CreatePromotionRequest",
                        "responseType": "squareup.solidshop.v2.service.CreatePromotionResponse"
                      },
                      "RetrievePromotion": {
                        "requestType": "squareup.solidshop.v2.service.RetrievePromotionRequest",
                        "responseType": "squareup.solidshop.v2.service.RetrievePromotionResponse"
                      },
                      "CreateWarrantyProduct": {
                        "requestType": "squareup.solidshop.v2.service.CreateWarrantyProductRequest",
                        "responseType": "squareup.solidshop.v2.service.CreateWarrantyProductResponse"
                      },
                      "CreateWarrantyProductsOrder": {
                        "requestType": "squareup.solidshop.v2.service.CreateWarrantyProductsOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.CreateWarrantyProductsOrderResponse"
                      },
                      "ListAllWarrantyProducts": {
                        "requestType": "squareup.solidshop.v2.service.ListAllWarrantyProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListAllWarrantyProductsResponse"
                      },
                      "ListWarrantyProducts": {
                        "requestType": "squareup.solidshop.v2.service.ListWarrantyProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListWarrantyProductsResponse"
                      },
                      "SearchWarrantyProducts": {
                        "requestType": "squareup.solidshop.v2.service.SearchWarrantyProductsRequest",
                        "responseType": "squareup.solidshop.v2.service.SearchWarrantyProductsResponse"
                      },
                      "ListProductTaxons": {
                        "requestType": "squareup.solidshop.v2.service.ListProductTaxonsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListProductTaxonsResponse"
                      },
                      "ListSoftwareProductGroups": {
                        "requestType": "squareup.solidshop.v2.service.ListSoftwareProductGroupsRequest",
                        "responseType": "squareup.solidshop.v2.service.ListSoftwareProductGroupsResponse"
                      },
                      "UpdateLineItemQuantity": {
                        "requestType": "squareup.solidshop.v2.service.UpdateLineItemQuantityRequest",
                        "responseType": "squareup.solidshop.v2.service.UpdateLineItemQuantityResponse"
                      },
                      "UpdateInternalLineItemQuantities": {
                        "requestType": "squareup.solidshop.v2.service.UpdateInternalLineItemQuantitiesRequest",
                        "responseType": "squareup.solidshop.v2.service.UpdateInternalLineItemQuantitiesResponse"
                      },
                      "RetrieveLatestActiveOrder": {
                        "requestType": "squareup.solidshop.v2.service.RetrieveLatestActiveOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.RetrieveLatestActiveOrderResponse"
                      },
                      "RetrieveIdvStatus": {
                        "requestType": "squareup.solidshop.v2.service.RetrieveIdvStatusRequest",
                        "responseType": "squareup.solidshop.v2.service.RetrieveIdvStatusResponse"
                      },
                      "RetrieveInternalOrder": {
                        "requestType": "squareup.solidshop.v2.service.RetrieveInternalOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.RetrieveInternalOrderResponse"
                      },
                      "RetrieveOrder": {
                        "requestType": "squareup.solidshop.v2.service.RetrieveOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.RetrieveOrderResponse"
                      },
                      "CreateInternalOrder": {
                        "requestType": "squareup.solidshop.v2.service.CreateInternalOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.CreateInternalOrderResponse"
                      },
                      "HideInternalOrder": {
                        "requestType": "squareup.solidshop.v2.service.HideInternalOrderRequest",
                        "responseType": "squareup.solidshop.v2.service.HideInternalOrderResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ShopService @ squareup/solidshop/v2/service/shop.proto at 32:1
 */
export const ShopService = $root.lookupService('squareup.solidshop.v2.service.ShopService');
